module.exports = __webpack_public_path__ + "img/twic-no.d8b73291.svg";